import * as React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Progress from 'rsuite/Progress'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'

import { ContributionMaterialType, UploadContributionMaterial } from '../../../store/contributions/contributionsTypings'
import { EphemeralMaterialType } from '../../../store/ephemeral/ephemeralTypings'

type Props = {
    progress?: number
    material?: ContributionMaterialType | EphemeralMaterialType
    uploadingMaterial?: UploadContributionMaterial
    cancel?: (item: UploadContributionMaterial | EphemeralMaterialType) => void
    deleteMaterial?: (material: ContributionMaterialType | EphemeralMaterialType) => void
}

const ImagePreview: React.FunctionComponent<Props> = ({
    progress = 0,
    material,
    uploadingMaterial,
    deleteMaterial,
    cancel
}: Props) => {
    const [loaded, setLoaded] = useState(false)
    const [t] = useTranslation()

    return (
        <div className={`imageContainer ${!loaded && 'uploading'}`}>
            <div className="controls">
                <div
                    className={`controlButton ${material ? 'controlButton_delete' : 'controlButton_cancel'}`}
                    onClick={() => (material ? deleteMaterial(material) : cancel(uploadingMaterial))}
                />
            </div>
            {(material && !material.status) || (material && material.status && material.status !== 'public') ? (
                <img onLoad={() => setLoaded(true)} src={material.thumbnail_url} alt="" />
            ) : (
                <></>
            )}
            {material && material.url && material.status && material.status == 'public' ? (
                <video controls onLoad={() => setLoaded(true)}>
                    <source src={material.url} type="video/mp4" />
                </video>
            ) : (
                <></>
            )}
            {/*@ts-ignore*/}
            {(material && !material.url && material.type && material.type === 'video') ||
            (material && material.status && material.status !== 'public') ? (
                <div className="video_Preparing">
                    <p>{t('video processing')}</p>
                    {/*@ts-ignore*/}
                    <span>{`${progress || material.processing_progress || 0}%`}</span>
                </div>
            ) : (
                <></>
            )}
            {uploadingMaterial && (
                <div className="preloader">
                    <CircularProgressbar
                        value={uploadingMaterial.progress}
                        text={`${uploadingMaterial.progress}%`}
                        styles={buildStyles({
                            textSize: '16px',
                            strokeLinecap: 'round',
                            pathTransitionDuration: 0.25,
                            // Colors
                            pathColor: '#104283',
                            textColor: '#104283',
                            trailColor: '#ececec'
                        })}
                    />
                </div>
            )}
            {material && material.error && <div className="error">{t(material.error)}</div>}
            {!loaded && !uploadingMaterial && !material.error && (
                <div className="preloader">
                    <div />
                    <div />
                    <div />
                    <div />
                </div>
            )}
        </div>
    )
}

export default ImagePreview
